import { CredentialsContext } from './credentials.component';

export const faqData = (context: CredentialsContext): any[] => {
  const { utility } = context;
  return [
    {
      answer:
        'When you integrate your utility account with Arcadia, we encrypt your account information using AWS KMS (Amazon Web Services Key Management Services). Your data is encrypted both in transit and in storage, and any attempt at decryption of your account information will be logged and tracked to ensure security.',
      name: 'data-privacy',
      question: 'Is my data safe?',
    },
    {
      answer:
        "No, there will be no change to your utility company. Arcadia's technology will send savings directly to your utility account to reduce the amount of your bill.",
      name: 'utility-company',
      question: 'Will my utility company change?',
    },
    {
      answer: (() => {
        return (
          <>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '1rem',
                marginBottom: '16px',
              }}
            >
              If we’re not able to connect to your utility account, try using the link below to
              reset your {utility.displayName} password. Then come back here to resubmit your login
              credentials.
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '1rem',
                marginBottom: '16px',
              }}
            >
              If we’re still not able to connect, you can click “I need help with this” or “Continue
              without logging in.” However, please note that you will need to resubmit your login
              credentials in your Arcadia dashboard at a later time.
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '1rem',
                marginBottom: '16px',
              }}
            >
              <a
                href={utility.forgotPassword!}
                style={{ color: '#0B1F1C', textDecoration: 'underline' }}
                target="_blank"
              >
                Reset your password
              </a>
            </div>
          </>
        );
      })(),
      name: 'unable-to-connect',
      question: "What if you can't connect to my utility account?",
    },
    {
      answer: (() => {
        return (
          <>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '1rem',
                marginBottom: '16px',
              }}
            >
              Click the link below to register for an online account with{' '}
              {context.utility.displayName}. Remember the login credentials you create and then come
              back here to complete your signup with Arcadia.
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '1rem',
                marginBottom: '16px',
              }}
            >
              <a
                href={utility.registerForAccount!}
                style={{ color: '#0B1F1C', textDecoration: 'underline' }}
                target="_blank"
              >
                Register for online account
              </a>
            </div>
          </>
        );
      })(),
      name: 'utility-account-creation',
      question: "What if I don't have an online account with my utility?",
    },
  ];
};
